<template>
    <div>
        <l-marker :lat-lng="[inmueble.latitud, inmueble.longitud]" @click="onclick">
            <l-icon :icon-size="iconSize" :icon-anchor="icon.iconAnchor" :icon-url="iconUrl"
                :popup-anchor="icon.popupAnchor" :shadow-url="iconShadow">
                <div>
                    <img :src="iconUrl">
                    <div class="label-mark">
                        <template v-if="inmueble.gestion.esArriendoVenta">
                            <strong>
                                $ {{ inmueble.valor_canon_format }}
                            </strong>
                        </template>
                        <template v-if="!inmueble.gestion.esArriendo">
                            <strong>
                                $ {{ inmueble.valor_venta_format }}
                            </strong>
                        </template>
                        <template v-if="inmueble.gestion.esArriendo">
                            <strong>
                                ${{ inmueble.valor_canon_format }}
                            </strong>
                        </template>
                    </div>
                </div>

            </l-icon>

            <template v-if="mostrarPopup">
                <l-popup>
                    <card-popup :inmueble="inmueble"></card-popup>
                </l-popup>
            </template>
        </l-marker>
    </div>
</template>
<script lang="ts">
import { LMarker, LPopup, LIcon, LCircleMarker } from 'vue2-leaflet';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Inmueble } from '@/Modelos/Inmueble';
import CardPopup from '@/components/Marcador/CardPopup.vue';
import { namespace } from "vuex-class";
import { ConfiguracionExterna } from '@/Modelos/ConfiguracionExterna';
const WidgetMapStore = namespace('WidgetMapStore');
import Marker from '@/resources/marker';

const URL_ICON = 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png';

@Component({
    components: {
        LMarker,
        LPopup,
        LIcon,
        LCircleMarker,
        CardPopup
    }
})
export default class Marcador extends Vue {

    @Prop({ required: true })
    private inmueble!: Inmueble;

    private icon: any;


    private markerSvg: Marker;

    @WidgetMapStore.State('configuracionExterna')
    configuracionExterna!: ConfiguracionExterna;

    constructor() {
        super();

        this.icon = {
            /**
             * colo de los marcadores
             * https://github.com/pointhi/leaflet-color-markers
             */
            iconUrl: URL_ICON,
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
            iconSize: [50, 70],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        };

        this.markerSvg = new Marker()


    }

    get mostrarPopup(): boolean {
        return this.configuracionExterna?.marcador?.actionPopup !== 'hidden';
    }


    get iconUrl(): any {

        //se valida que tipo de icoono se quiere
        //ICONO o ColorSVG
        if (this.esIconoColor) {
            if (this.inmueble.destacado) {
                return this.markerSvg.destacado(this.configuracionExterna?.theme?.color?.primary)
            }
            return this.markerSvg.generarIc(this.configuracionExterna?.theme?.color?.primary)

        } else {
            if (this.inmueble.destacado) {
                return this.configuracionExterna?.marcador?.icon?.destacado ?
                    this.configuracionExterna.marcador.icon.destacado :
                    URL_ICON;
            }
            return this.configuracionExterna?.marcador?.icon?.default ?
                this.configuracionExterna?.marcador?.icon?.default :
                URL_ICON;
        }
    }

    get iconSize() {
        if (this.inmueble.destacado) {
            return [50, 70];
        }
        return [25, 25];
    }
    get iconShadow() {
        return this.esIconoColor ? null : this.icon.shadowUrl
    }

    get esIconoColor() {
        return this.configuracionExterna?.marcador?.icon?.tipoColor;
    }

    onclick() {
        this.$emit("click");
    }

}
</script>


<style lang="scss" scoped>
::v-deep .label-mark {
    width: 100px !important;
    strong {
        background-color: white;
        padding: 2px;
        border-radius: 7px;
    }

}
</style>